class GeneralModal extends HTMLElement {
  connectedCallback() {
    const trigger = this.querySelector('.js-modal-trigger')
    if (trigger) {
      trigger.addEventListener('click', () => this.openModal())
    }
  }

  openModal() {
    const contentDiv = this.querySelector('.general-modal-content')
    if (!contentDiv) return

    const trigger = this.querySelector('.js-modal-trigger')
    if (trigger.classList.contains('js-product-star-rating')) return

    customElements.whenDefined('dynamic-modal').then(() => {
      const DynamicModalClass = customElements.get('dynamic-modal')
      if (!DynamicModalClass || typeof DynamicModalClass.getInstance !== 'function') return

      const modal = DynamicModalClass.getInstance()
      const modalContent = modal.querySelector('.dynamic-modal__content')
      if (!modalContent) return

      modalContent.innerHTML = contentDiv.innerHTML
      modal.open()
    })
  }
}

customElements.define('general-modal', GeneralModal)
